export const SIGNUP = 'SIGNUP';
export const LOGIN = 'LOGIN';
export const UPDATE = 'UPDATE';
export const LOGOUT = 'LOGOUT';
export const ADMIN_GET_USER_CAMPAIGN = 'ADMIN_GET_USER_CAMPAIGN';
export const SET_DYNAMICS_TOKEN = "SET_DYNAMICS_TOKEN";
